













































import Vue from 'vue';
import { ListOptionsTokenized } from '../common';
import { OperationPair } from 'expangine-runtime';
import { Registry } from '../runtime/Registry';
import { filterOperation, sortListOptionByCount, sortListOption, getListOption } from '../runtime/exprs/operation/helpers';


export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
  },
  data: () => ({
    query: '',
    viewingName: '',
    viewing: false,
  }),
  computed: {
    visible: {
      get(): boolean {
        return this.show;
      },
      set(visible: boolean)  {
        this.$emit('update:show', visible);
      },
    },
    items(): ListOptionsTokenized<OperationPair> {
      let items = this.registry.defs.getOperations()
        .filter((pair) => this.registry.isValidOperation(pair))
        .map((pair) => getListOption(this.registry, pair))
      ;

      if (this.query) {
        items = items.filter((item) => filterOperation(item, this.query, item.text));
        items.sort(sortListOptionByCount(this.query));
      } else {
        items.sort(sortListOption);
      }

      return items;
    },
  },
  methods: {
    view(value: OperationPair) {
      this.viewingName = value.op.id;
      this.viewing = true;
    },
  },
});
